export default __webpack_public_path__ + "static/media/e.73b73c08.mp3";